import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.ticketForm.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "ticketFormSearch",
  fields: [
    name
  ]
}
